import { render } from "./sectionContest.vue?vue&type=template&id=e2c767c4&scoped=true"
import script from "./sectionContest.vue?vue&type=script&lang=js"
export * from "./sectionContest.vue?vue&type=script&lang=js"

import "./sectionContest.vue?vue&type=style&index=0&id=e2c767c4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2c767c4"]])

export default __exports__